module.exports = __webpack_public_path__ + "img/edit.54daad02.svg";